import { LicensesRoutes } from '@routes';
import { IconWrapper } from '@components/shared/IconWrapper';
import CustomIcon from '@components/shared/CustomIcon/CustomIcon';

const ROWS_PER_PAGE = [10, 20, 100, 500, 1_000, 2_000];

export const ADDITIONAL_INFO_LICENSES_TEXT = {
  vacaciones: [
    'Son días corridos (no hábiles).',
    'Deberán comenzar el primer día hábil de la semana y se pueden fraccionar siempre que sea en múltiplos de 7 días.',
    'Debés solicitarlas con una antelación mínima de 30 días, para poder gestionar el adelanto vacacional.',
  ],
  tramites: [
    'Disponés de 6 días por motivos personales por año.',
    'No pueden ser días consecutivos entre sí, ni con otras licencias.',
    'Se pueden fraccionar de a medio día y no es necesario presentar comprobante.',
  ],
  examen: [
    'Hasta 3 días corridos, incluyendo el día del examen, salvo carreras afines que se extiende a 4.',
    'Deberás presentar el certificado dentro del término de 30 días.',
  ],
  medical: [
    'Cargando la fecha “Desde” se dará comienzo a la solicitud de licencia; la fecha “Hasta” la completará el Servicio Médico.',
    'Requiere certificado médico. No se aceptarán los expedidos de manera online.',
  ],
  maternidad: [
    'Tiene una duración total de 90 días corridos.',
    'Pueden ser 45 días previos y 45 posteriores o, como mínimo, 10 días previos y 80 posteriores.',
    'Debes contar con 12 semanas de gestación y presentar el Certificado de Embarazo.',
    'No olvides iniciar el trámite para la Asignación por Maternidad en ANSES.',
    'Luego del nacimiento deberás enviar a RRHH la documentación del bebé.',
  ],
  mudanza: [
    'Debes completar y adjuntar a la solicitud la Declaración Jurada de Domicilio.',
    'La licencia por mudanza solo contempla un día.',
  ],
  matrimonio: [
    'Es de 12 días corridos desde el momento en que se constituye legítimamente.',
    'Debes completar y adjuntar la Planilla de Licencia por Matrimonio firmada por tu jefe o gerente.',
    'Al momento de tu reincorporación debés enviar a RRHH copia de la libreta de matrimonio, DNI y CUIL de tu cónyuge.',
  ],
  paternidad: [
    'Son 7 días hábiles (no corridos) desde el momento del nacimiento.',
    'Dentro de los primeros días luego del nacimiento debés enviar a RRHH la documentación del bebé.',
  ],
  excedencia: [
    'Aplica a continuación de la licencia por Maternidad y se debe solicitar al menos 48 horas antes de la finalización de la misma.',
    'Debe ser un período no inferior a 3 meses ni superior a 6 meses.',
    'Implica quedar en situación de excedencia, sin goce de sueldo, ni aportes y contribución a la obra social (estos últimos quedan a cargo de la trabajadora).',
  ],
  sin_goce_de_sueldo: [
    'Debes completar y adjuntar a la solicitud la Planilla de Licencia sin Goce de Sueldo firmada por tu gerente.',
    'Se computa inclusive hasta el día previo a la reincorporación.',
  ],
  citacion_judicial: [
    'En caso de citación judicial debidamente notificada, se otorgará el tiempo necesario para concurrir al trámite judicial.',
    'Posteriormente se deberá presentar el certificado de asistencia correspondiente.',
  ],
  fallecimiento_familiar: [
    'En caso de fallecimiento familiar la cantidad de días de licencia depende del grado de parentesco:',
    'Padres, padrastros, hijos, hijastros, y hermanos (incluso los unilaterales): 5 días.',
    'Abuelos, abuelos políticos, nietos, nietos políticos, cuñados, suegros, nueras y yernos: 2 días.',
    'Tíos, sobrinos, primos: 1 día.',
  ],
  gremial: [
    'Ante el previo requerimiento de la asociación sindical y por razones vinculadas a la administración interna de ella, la empresa autorizará a los delegados indicados a dejar de prestar servicios en forma circunstancial (permiso) o en forma estable (licencia).',
  ],
  bomberos: [
    'Debés presentar el certificado o comprobante que justifique dicha actividad.',
  ],
  deportiva: [
    'Debés contar con al menos 6 meses de antigüedad.',
    'No puede superar los 30 días por año.',
    'Debes completar y adjuntar a Planilla de Comunicación de Licencia Especial Deportiva firmada por tu jefe o gerente.',
    'Debés adjuntar la documentación respaldatoria correspondiente.',
  ],
  religiosa: [
    'Es para personas que profesan religión no católica.',
    'Tienen carácter similar a días no laborables según indica el Calendario de Feriados Nacionales.',
  ],
  donacion_sangre: [
    'Se otorga por el día completo.',
    'Podés tener un máximo de 4 donaciones por año, con un intervalo de 90 días entre cada extracción.',
    'Debe presentar posteriormente el certificado correspondiente.',
  ],
  enfermedad_familiar: [
    'Hasta 6 días continuos o discontinuos por año calendario para el grupo familiar constituido en el hogar.',
    'Cuando la enfermedad revista extrema gravedad, esta licencia podrá ampliarse hasta 25 días.',
    'Para atender al padre o madre enfermos que habiten fuera del domicilio, un máximo de 6 días continuos o discontinuos por año calendario, cuando se compruebe fehacientemente que el trabajador es el único que lo puede asistir.',
    'En todos los casos deberás presentar los certificados médicos que avalen dicha solicitud.',
  ],
};

export const LICENCIA_ESTADO = {
  EN_PROCESO: 'in_process',
  PENDIENTE_RRHH: 'hr_pending',
  RECHAZADA: 'rejected',
  CONFIRMADA: 'confirmed',
  CANCELADA: 'cancelled',
  INTERRUMPIDA: 'interrupted',
  APROBADA_RRHH: 'rrhh_approved',
  STAND_BY: 'stand_by',
  DOCUMENTO_PENDIENTE: 'document_pending',
  DOCUMENTO_CARGADO: 'document_loaded',
  JUSTIFICADA: 'justified',
  NO_JUSTIFICADA: 'not_justified',
  A_DESCONTAR: 'to_be_discounted',
  MODIFICADA: 'modified',
  NO_A_DESCONTAR: 'not_to_be_discounted',
  ACCION_REQUERIDA: 'accion_requerida',
  APROBACION_AUTOMATICA: 'aprobacion_24_hs',
  EXTENSION_EN_EVALUACION: 'extension_en_evaluacion',
  OBJETADA: 'objected',
  ACTIVA: 'activa',
};

export const LICENCIA_ESTADO_AUTORIZACION = {
  MANUAL: 'manual',
  APROBACION_AUTOMATICA: 'automatica_24_hs',
};

export const LICENCIAS_GANTT = {
  vacation: {
    color: { rrhh_approved: '#F89DC7', synchronized: '#F89DC7' },
    title: 'Licencia por Vacaciones',
    shortTitle: 'Vacaciones',
  },
  medical: {
    color: { justified: '#A9DDD9' },
    title: 'Licencia por Enfermedad',
    shortTitle: 'Enfermedad',
  },
  procedure: {
    color: { rrhh_approved: '#FBCF9C' },
    title: 'Licencia por Motivos Personales',
    shortTitle: 'Motivos Personales',
  },
  exam: {
    color: {
      rrhh_approved: '#FBCF9C',
      justified: '#FBCF9C',
      document_pending: '#FBCF9C',
    },
    title: 'Licencia por Día de Examen',
    shortTitle: 'Examen',
  },
  enfermedad_familiar: {
    color: { justified: '#A9DDD9' },
    title: 'Enfermedad familiar',
    shortTitle: 'Enfermedad familiar',
  },
  art: {
    color: { activa: '#A9DDD9' },
    title: 'art',
    shortTitle: 'art',
  },
  religiosa: {
    color: { rrhh_approved: '#BDB2DD' },
    title: 'Religiosa',
    shortTitle: 'Religiosa',
  },
  mudanza: {
    color: { rrhh_approved: '#BDB2DD' },
    title: 'Mudanza',
    shortTitle: 'Mudanza',
  },
  matrimonio: {
    color: { rrhh_approved: '#BDB2DD' },
    title: 'Matrimonio',
    shortTitle: 'Matrimonio',
  },
  maternidad: {
    color: { rrhh_approved: '#BDB2DD' },
    title: 'Maternidad',
    shortTitle: 'Maternidad',
  },
  paternidad: {
    color: { rrhh_approved: '#BDB2DD' },
    title: 'Paternidad',
    shortTitle: 'Paternidad',
  },
  excedencia: {
    color: { rrhh_approved: '#BDB2DD' },
    title: 'Excedencia',
    shortTitle: 'Excedencia',
  },
  sin_goce_de_sueldo: {
    color: { rrhh_approved: '#BDB2DD' },
    title: 'Sin goce de sueldo',
    shortTitle: 'Sin goce de sueldo',
  },
  bomberos: {
    color: { rrhh_approved: '#BDB2DD' },
    title: 'Bomberos',
    shortTitle: 'Bomberos',
  },
  deportiva: {
    color: { rrhh_approved: '#BDB2DD' },
    title: 'Deportiva',
    shortTitle: 'Deportiva',
  },
  gremial: {
    color: { rrhh_approved: '#BDB2DD' },
    title: 'Gremial',
    shortTitle: 'Gremial',
  },
  citacion_judicial: {
    color: { rrhh_approved: '#BDB2DD' },
    title: 'Citación Judicial',
    shortTitle: 'Citación Judicial',
  },
  fallecimiento_familiar: {
    color: { rrhh_approved: '#BDB2DD' },
    title: 'Fallecimiento familiar',
    shortTitle: 'Fallecimiento familiar',
  },
  donacion_sangre: {
    color: { justified: '#A9DDD9', not_justified: '#A9DDD9' },
    title: 'Donación de sangre',
    shortTitle: 'Donación de sangre',
  },
  manual: {
    color: { rrhh_approved: '#BDB2DD' },
    title: 'Licencia manual',
    shortTitle: 'Manual',
  },
};

export const TREE_STATUS = {
  authorized: 'Autorizó',
  loaded: 'Solicitud generada',
  rejected: 'Rechazó',
  confirmed: 'Aprobó',
  'not-objected': 'No objetó',
  cancelled: 'Canceló',
  interrupted: 'Interrumpió',
  rrhh_approved: 'Aprobó recursos humanos',
  stand_by: 'En revisión',
  pending: 'Pendiente',
  document_loaded: 'Documentación en evaluación',
  'file-uploaded': 'Documentación enviada',
  justified: 'Justificó',
  not_justified: 'Sin justificar',
  to_be_discounted: 'A descontar',
  modified: 'Licencia modificada',
  not_to_be_discounted: 'Sin descuento',
  objected: 'Objetó',
  extension_en_evaluacion: 'Extensión solicitada',
  mensaje_user: 'Mensaje enviado',
  mensaje_doctor: 'Mensaje recibido',
  mensaje_rrhh: 'Mensaje recibido: RRHH',
  justificacion_cargada: 'Justificación cargada',
  rechazo_el_area: 'Rechazó el área',
  a_descuento: 'A descuento',
  synchronized: 'Procesó: RRHH',
};

export const automaticApprovalHours = '48';

export const STATUS_PROCESS_AUTHORIZATION = {
  manual: 'Manual',
  automatica_24_hs: `Automática ${automaticApprovalHours}h`,
};

export const APROVAL_STATUS_DESCRIPTIONS = {
  document_pending: {
    medical: `El solicitante tiene ${automaticApprovalHours} horas desde el inicio de la ausencia para cargar el justificante, de lo contrario se descontarán los días no trabajados.`,
    exam: 'El solicitante tiene 30 días desde el inicio de la ausencia para cargar el justificante, de lo contrario se le descontarán los días no trabajados.',
    enfermedad_familiar: `El solicitante tiene ${automaticApprovalHours} horas desde el inicio de la ausencia para cargar el justificante, de lo contrario se descontarán los días no trabajados.`,
    donacion_sangre: `El solicitante tiene ${automaticApprovalHours} horas desde el inicio de la ausencia para cargar el justificante, de lo contrario se descontarán los días no trabajados.`,
    donacion_de_sangre: `El solicitante tiene ${automaticApprovalHours} horas desde el inicio de la ausencia para cargar el justificante, de lo contrario se descontarán los días no trabajados.`,
  },
  document_loaded:
    'El solicitante adjuntó el certificado correspondiente y se encuentra a la espera de la resolución de Recursos Humanos.',
  objected: {
    medical:
      'El Servicio Médico objetó la solicitud de extensión de la licencia.',
  },
  extension_en_evaluacion: {
    medical:
      'El solicitante pidió una extensión de la licencia adjuntando el certificado correspondiente y se encuentra a la espera de la resolución del Servicio Médico.',
  },
};

export const LICENCIAS_FILTROS_POR_DEFECTO = {
  types: [],
  sort_field: 'from_date',
  sort_order: -1,
  page_num: 1,
  q: '',
  status_process: [],
  page_size: ROWS_PER_PAGE[0],
  vista: 'tu_equipo',
  idUserCompartido: null,
};

export const ALL_LICENSES = '/todas';

export const MEDICAL_LICENSES_TYPES = {
  donacion_sangre: 'donacion_sangre',
  enfermedad_familiar: 'enfermedad_familiar',
  medical: 'medical',
};

export const LICENSES_TYPES = {
  vacaciones: 'vacation',
  tramites: 'procedure',
  examen: 'exam',
  otras: 'others',
  mudanza: 'mudanza',
  matrimonio: 'matrimonio',
  maternidad: 'maternidad',
  paternidad: 'paternidad',
  excedencia: 'excedencia',
  sin_goce_de_sueldo: 'sin_goce_de_sueldo',
  citacion_judicial: 'citación_judicial',
  fallecimiento_familiar: 'fallecimiento_familiar',
  deportiva: 'deportiva',
  gremial: 'gremial',
  religiosa: 'religiosa',
  bomberos: 'bomberos',
  art: 'art',
  ...MEDICAL_LICENSES_TYPES,
};

export const OTHER_LICENSES = {
  deportiva: 'Deportiva',
  gremial: 'Gremial',
  religiosa: 'Religiosa',
  bomberos: 'Bomberos voluntarios',
};

export const WORKFLOW_STATUS = { FINISHED: 'Finished' };

export const NAMES_LICENSE_SWITCH = {
  mudanza: 'Mudanza',
  matrimonio: 'Matrimonio',
  maternidad: 'Maternidad',
  paternidad: 'Paternidad',
  excedencia: 'Excedencia',
  sin_goce_de_sueldo: 'Sin goce de sueldo',
  citacion_judicial: 'Citación judicial',
  fallecimiento_familiar: 'Fallecimiento familiar',
  enfermedad_familiar: 'Enfermedad familiar',
  donacion_de_sangre: 'Donación de sangre',
};

export const LICENSES_TYPES_NAME_TABLE = {
  vacation: 'Vacaciones',
  procedure: 'Motivos Personales',
  exam: 'Examen',
  medical: 'Enfermedad',
  others: 'Otras licencias (Descargables/Manual)',
  mudanza: 'Mudanza',
  matrimonio: 'Matrimonio',
  maternidad: 'Maternidad',
  paternidad: 'Paternidad',
  excedencia: 'Excedencia',
  sin_goce_de_sueldo: 'Sin Goce de Sueldo',
  citacion_judicial: 'Citación Judicial',
  fallecimiento_familiar: 'Fallecimiento familiar',
  donacion_sangre: 'Donación de sangre',
  enfermedad_familiar: 'Enfermedad familiar',
  art: 'ART',
  ...OTHER_LICENSES,
};

export const LICENSES_STATUS_KEYS = {
  in_process: 'in_process',
  hr_pending: 'hr_pending',
  rejected: 'rejected',
  rrhh_approved: 'rrhh_approved',
  cancelled: 'cancelled',
  document_pending: 'document_pending',
  document_loaded: 'document_loaded',
  to_be_discounted: 'to_be_discounted',
  not_to_be_discounted: 'not_to_be_discounted',
  interrupted: 'interrupted',
  justified: 'justified',
  not_justified: 'not_justified',
  objected: 'objected',
  extension_en_evaluacion: 'extension_en_evaluacion',
  manual: 'manual',
  synchronized: 'synchronized',
  all: 'all',
};

export const TREE_STATUS_NOTES = {
  authorized: 'Solicitud autorizada',
  'not-objected': 'Solicitud no objetada',
  loaded: 'Solicitud generada',
  rejected: 'Solicitud rechazada',
  confirmed: 'Solicitud aprobada',
  cancelled: 'Solicitud cancelada',
  interrupted: 'Solicitud interrumpida',
  rrhh_approved: 'Solicitud aprobada por recursos humanos',
  stand_by: 'Solicitud en espera',
  pending: 'Solicitud pendiente',
  document_loaded: 'Documentación enviada',
  justified: 'Solicitud justificada',
  not_justified: 'Solicitud sin justificar',
  to_be_discounted: 'Solicitud a descontar',
  modified: 'Solicitud modificada',
  not_to_be_discounted: 'Solicitud sin descuento',
  objected: 'Solicitud objetada',
  mensaje_user: 'Mensaje enviado',
  mensaje_doctor: 'Mensaje recibido',
  objetada: 'Registro objetado',
  mensaje_rrhh: 'Mesaje recibido',
  cambio_estado: 'Cambió de estado',
  synchronized: 'Procesó: RRHH',
};

export const TREE_STATUS_REFUND_DAYS = {
  interrupted: 'devueltos',
  to_be_discounted: 'a descontar',
  default: 'solicitados',
};

export const ITEM_BREADCRUMBS_LICENCIAS = {
  tuArsat: { title: 'Tu ARSAT', link: '/tu-arsat' },
  licencias: { title: 'Licencias', link: '/tu-arsat/licencias' },
  vacation: { title: 'Vacaciones' },
  procedure: { title: 'Motivos Personales' },
  exam: { title: 'Día de Examen' },
  medical: { title: 'Enfermedad' },
  donacion_sangre: { title: 'Donación de Sangre' },
  enfermedad_familiar: { title: 'Enfermedad Familiar' },
  all: { title: 'Todas' },
  myTeam: { title: 'Tu equipo', link: '/equipo' },
  detail: { title: 'Detalle' },
  allLicenses: {
    title: 'Listado Todas las licencias',
    link: LicensesRoutes.listLicenses,
  },
  scheduleLicenses: {
    title: 'Cronograma de Ausencias',
    link: LicensesRoutes.schedulerLicenses,
  },
};

export const breadcrumbsLicenses = [
  ITEM_BREADCRUMBS_LICENCIAS.tuArsat,
  ITEM_BREADCRUMBS_LICENCIAS.licencias,
];

export const breadcrumbsVacations = [
  ...breadcrumbsLicenses,
  ITEM_BREADCRUMBS_LICENCIAS.vacation,
];

export const breadcrumbsProcedure = [
  ...breadcrumbsLicenses,
  ITEM_BREADCRUMBS_LICENCIAS.procedure,
];

export const breadcrumbsExam = [
  ...breadcrumbsLicenses,
  ITEM_BREADCRUMBS_LICENCIAS.exam,
];

export const breadcrumbsMedical = [
  ...breadcrumbsLicenses,
  ITEM_BREADCRUMBS_LICENCIAS.medical,
];

export const breadcrumbsDonacionSangre = [
  ...breadcrumbsLicenses,
  ITEM_BREADCRUMBS_LICENCIAS.donacion_sangre,
];

export const breadcrumbsEnfermedadFamiliar = [
  ...breadcrumbsLicenses,
  ITEM_BREADCRUMBS_LICENCIAS.enfermedad_familiar,
];

export const breadcrumbsAll = [
  ...breadcrumbsLicenses,
  ITEM_BREADCRUMBS_LICENCIAS.all,
];

export const breadcrumbsAllLicenses = [
  ITEM_BREADCRUMBS_LICENCIAS.myTeam,
  ITEM_BREADCRUMBS_LICENCIAS.allLicenses,
];

export const breadcrumbsScheduleLicenses = [
  ITEM_BREADCRUMBS_LICENCIAS.myTeam,
  ITEM_BREADCRUMBS_LICENCIAS.scheduleLicenses,
];

export const breadcrumbsRequestLicence = [
  ...breadcrumbsLicenses,
  ITEM_BREADCRUMBS_LICENCIAS.detail,
];

export const breadcrumbsIsAprovalView = [
  ...breadcrumbsAllLicenses,
  ITEM_BREADCRUMBS_LICENCIAS.detail,
];

export const getBreadcrumbsType = (type: any) => {
  return [...breadcrumbsLicenses, { title: type }];
};

const inProcces = { in_process: 'En Proceso' };
const hrPending = { hr_pending: 'En RRHH' };
const rejected = { rejected: 'Rechazada' };
const rrhhApproved = { rrhh_approved: 'Aprobada' };
const cancelled = { cancelled: 'Cancelada' };
const documentPending = { document_pending: 'Falta documentación' };
const documentLoaded = { document_loaded: 'Documentación en evaluación' };
const toBeDiscounted = { to_be_discounted: 'A descuento' };
const notToBeDiscounted = { not_to_be_discounted: 'Sin descuento' };
const interrupted = { interrupted: 'Interrumpida' };
const justified = { justified: 'Justificada' };
const notJustified = { not_justified: 'Sin justificar' };
const actionRequired = { accion_requerida: 'Accion requerida' };
const automaticApproval = {
  aprobacion_24_hs: `Aprobación automática ${automaticApprovalHours}hs`,
};
const extensionInEvaluation = {
  extension_en_evaluacion: 'Extensión en evaluación',
};
const objected = { objected: 'Extensión objetada' };
const activa = { activa: 'ART Registrada' };
const manual = { manual: 'Registro manual' };
const synchronized = { synchronized: 'Procesada por RRHH' };

export const APPROVAL_EVENT = {
  APPROVE: 'approve',
  REJECT: 'reject',
};

export const LICENSES_OPTIONS_SPECIALS = {
  all: 'Todos',
};

export const LICENSES_TYPES_FULL_NAME = {
  vacation: 'Vacaciones',
  procedure: 'Motivos Personales',
  exam: 'Día de Examen',
  medical: 'Enfermedad',
  mudanza: 'Mudanza',
  matrimonio: 'Matrimonio',
  maternidad: 'Maternidad',
  paternidad: 'Paternidad',
  excedencia: 'Excedencia',
  sin_goce_de_sueldo: 'Sin Goce de Sueldo',
  citacion_judicial: 'Citación Judicial',
  fallecimiento_familiar: 'Fallecimiento Familiar',
  deportiva: 'Deportiva',
  gremial: 'Gremial',
  religiosa: 'Religiosa',
  bomberos: 'Bomberos Voluntarios',
  donacion_sangre: 'Donación de Sangre',
  enfermedad_familiar: 'Enfermedad Familiar',
  art: 'ART',
};

export const LICENSES_TYPES_FULL_NAME_FOR_ALL_REQUESTS = {
  ...LICENSES_TYPES_FULL_NAME,
  procedure: 'Motivos Personales',
  exam: 'Examen',
  ...LICENSES_OPTIONS_SPECIALS,
};

export const LICENSES_STATUS = {
  ...inProcces,
  ...hrPending,
  ...rejected,
  ...rrhhApproved,
  ...cancelled,
  ...documentPending,
  ...documentLoaded,
  ...toBeDiscounted,
  ...notToBeDiscounted,
  ...interrupted,
  ...justified,
  ...notJustified,
  ...objected,
  ...extensionInEvaluation,
  ...manual,
  ...synchronized,
  ...activa,
  ...LICENSES_OPTIONS_SPECIALS,
};

export const LICENSES_TEAM_STATUS = {
  ...inProcces,
  ...hrPending,
  ...rejected,
  ...rrhhApproved,
  ...cancelled,
  ...documentPending,
  ...documentLoaded,
  ...toBeDiscounted,
  ...notToBeDiscounted,
  ...interrupted,
  ...justified,
  ...notJustified,
  ...objected,
  ...extensionInEvaluation,
  ...manual,
  ...synchronized,
  ...activa,
};

export const LICENSES_GANTT_STATUS = {
  ...inProcces,
  ...hrPending,
  ...rrhhApproved,
  ...documentPending,
  ...documentLoaded,
  ...toBeDiscounted,
  ...notToBeDiscounted,
  ...interrupted,
  ...justified,
  ...notJustified,
  ...objected,
  ...extensionInEvaluation,
  ...manual,
  ...synchronized,
  ...LICENSES_OPTIONS_SPECIALS,
};

export const LICENSES_STATUS_BOSS = {
  ...LICENSES_STATUS,
  ...actionRequired,
  ...automaticApproval,
};

export const LICENSES_CIRCUITO_STEP_GREY = {
  ...documentPending,
  ...documentLoaded,
  hr_pending: 'Debe aprobar: RRHH -',
  in_process: 'Debe autorizar: ',
};

export const MANUAL_LICENSE_TYPES_NAMES = {
  franco_compensatorio: 'Franco Compensatorio',
  compensacion_de_horas: 'Compensación de Horas',
  otros: 'Otros',
};

export const MANUAL_LICENSE_TYPE_OTHERS = 'otros';

export const LICENSES_ALL_TYPES = {
  ...LICENSES_TYPES_FULL_NAME,
  ...MANUAL_LICENSE_TYPES_NAMES,
  ...LICENSES_OPTIONS_SPECIALS,
};

export const TYPE_INSTRUCTIVE = 'instructivo';

export const MODALITY_OPTIONS = [
  {
    label: 'Día completo',
    value: 'full_day',
  },
  {
    label: 'Medio día (tarde)',
    value: 'afternoon',
  },
  {
    label: 'Medio día (mañana)',
    value: 'morning',
  },
];

export const MODALITIES = {
  full_day: 'Día completo',
  afternoon: 'Medio día (tarde)',
  morning: 'Medio día (mañana)',
};

export const MANUAL_LICENSE = 'manual';

const IconLicensesCard = ({
  name,
  color = '#ffffff',
  bg,
  weight,
  size,
}: any) => (
  <IconWrapper
    background={bg}
    height={28}
    width={28}
    padding={'3.5px 4px 4.5px'}
  >
    <CustomIcon name={name} color={color} weight={weight} size={size} />
  </IconWrapper>
);

export const LICENSES_STATUS_ICONS = {
  rejected: <IconLicensesCard name='XCircle' bg={'#d32f2f'} />,
  to_be_discounted: <IconLicensesCard name='WarningCircle' bg={'#d32f2f'} />,
  not_justified: <IconLicensesCard name='WarningCircle' bg={'#d32f2f'} />,
  approved: <IconLicensesCard name='CheckCircle' bg={'#2e7d32'} />,
  rrhh_approved: <IconLicensesCard name='CheckCircle' bg={'#2e7d32'} />,
  justified: <IconLicensesCard name='CheckCircle' bg={'#2e7d32'} />,
  interrupted: <IconLicensesCard name='Prohibit' bg={'#535554'} />,
  document_pending: <IconLicensesCard name='WarningCircle' bg={'#ed6c02'} />,
  document_loaded: <IconLicensesCard name='Clock' bg={'#ed6c02'} />,
  in_process: <IconLicensesCard name='Clock' bg={'#50B8B1'} />,
  hr_pending: <IconLicensesCard name='Clock' bg={'#50B8B1'} />,
  cancelled: <IconLicensesCard name='Prohibit' bg={'#535554'} />,
  objected: <IconLicensesCard name='Prohibit' bg={'#535554'} />,
  extension_en_evaluacion: <IconLicensesCard name='Clock' bg={'#ed6c02'} />,
  activa: <IconLicensesCard name='CheckCircle' bg={'#2e7d32'} />,
  synchronized: <IconLicensesCard name='CheckCircle' bg={'#2e7d32'} />,
};

export const LICENSE_ERRORS = (days: any) => {
  return {
    'limit-of-days-reached': `La cantidad de días no puede ser mayor a ${days} dias`,
  };
};

export const TIME_TO_UPLOAD_CERTIFICATE = '24';
export const TIME_TO_REQUEST_MEDICAL_EXTENSION = 24 * 7;

export const STATUS_DESCRIPTIONS_LICENSES = {
  document_pending: {
    medical: `Tenés ${TIME_TO_UPLOAD_CERTIFICATE} horas desde el inicio de la ausencia para cargar el justificante, de lo contrario se descontarán los días no trabajados.`,
    exam: 'Tenés 30 días desde el inicio de la ausencia para cargar el justificante, de lo contrario se descontarán los días no trabajados.',
    enfermedad_familiar: `Tenés ${TIME_TO_UPLOAD_CERTIFICATE} horas desde el inicio de la ausencia para cargar el justificante, de lo contrario se descontarán los días no trabajados.`,
  },
  document_loaded: {
    medical:
      'En cuanto el Servicio Médico verifique la información adjunta, recibirás una notificación con los resultados.',
    exam: 'En cuanto Recursos Humanos verifique la información adjunta, recibirás una notificación con los resultados.',
  },
  extension_en_evaluacion: {
    medical:
      'En cuanto el Servicio Médico verifique la información adjunta, recibirás una notificación con los resultados.',
  },
  rectificacion_rechazada:
    'Debes resolver la situación de lo contrario no podrás seguir solicitando viáticos.',
};

export const WARNING_NAMES = {
  COINCIDENT_MEDICAL_LICENSE: 'coincident-medical-license',
};

export const QUERY_KEYS_LICENCIAS = {
  AUTOCOMPLETE_USER_BOSS: 'licencias_autocomplete_user_boss',
  AUTOCOMPLETE_USER_SHARE: 'licencias_autocomplete_user_share',
  TODAS: 'licencias_todas',
  OTRAS_LICENCIAS: 'licencias_otras_licencias',
};
